import { Component, Input, Output, ViewChild, EventEmitter, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { NewmemberService } from '../../services/newmember.service';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MessageService } from 'primeng/api';

// {{phnum.substring(0,2)} }******{{phnum.substring(8,10)}}
@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {
  @Input() otprequest;
  @Input() popup;
  @Output() verifiedOTP = new EventEmitter();
  @Output() OTPGenerated = new EventEmitter();
  @ViewChild('otp0')
  otp0: any;
  fieldName1: any;
  myform: FormGroup;
  otpShowHide: boolean = false;
  showOrHide: boolean = false;
  errorCheck: boolean = false;
  isCountDownExpired: boolean = false;
  countDownTime: number = 60;
  phoneNbr: string;  
  type:string = "MOBILE";

  constructor(public nms: NewmemberService,
              private messageService: MessageService) {
  }

  ngOnInit() {
    if (this.popup) {
      this.generateOTP();
    }
    this.phoneNbr = (this.otprequest && this.otprequest.phoneNbr != undefined) ? this.otprequest.phoneNbr : "";
  }

  public reInt(){
    this.showOrHide = false;
  }

  toLowerCase(text) {
    return text != null ? text.toLowerCase() : text;
  }

  switchOTPMode() {
    this.type = this.type === "EMAIL" ? "MOBILE" : "EMAIL";
    this.generateOTP();
  }


  public generateOTP() {
    this.otprequest.email = this.otprequest.email === 'MEMBER NOT PRESENT' ? '' : this.otprequest.email;
    
    this.countDownTime = 60;
    this.countDownTimer();
    var isError = false;
    
    if (this.otprequest.apiType != null && this.otprequest.apiType === "MEMBER_VERIFY") {
      var otpInfo: any = {};
      otpInfo.membershipNbr = this.otprequest.membershipNbr;
      otpInfo.cardHolderNbr = this.otprequest.cardHolderNbr;
      otpInfo.membershipId = this.otprequest.maMembershipId;
      otpInfo.category = this.otprequest.category;
      otpInfo.mailId = this.toLowerCase(this.otprequest.email);
      this.nms.generateMemberOTP(otpInfo).subscribe((res: any) => {
       
        if (res.code === 'SUCCESS') {
          if (res.response.phoneNbr != null)     {
            this.OTPGenerated.emit(true);
            this.messageService.add({severity: 'success', summary: 'Generate OTP', detail: 'OTP Sent Successfully!'});
            this.showOrHide = true;
            this.errorCheck = false;
            this.phoneNbr =  res.response.phoneNbr;
            setTimeout(() => {            
              this.otp0.nativeElement.value = '';
              this.otp0.nativeElement.focus();            
            }, 1000);
          } else {
            this.OTPGenerated.emit(false);
            isError = true;
            this.messageService.add({severity: 'error', summary: 'Generate OTP', detail: 'No Data Found, Please contact nearest store.'});
            this.showOrHide = true;
            this.errorCheck = true;
          }
        } else {
          this.OTPGenerated.emit(false);
          if (!isError) {
            isError = true;
            this.messageService.add({severity: 'error', summary: 'Generate OTP', detail: 'OTP sms generate failed'});
            this.showOrHide = true;
            this.errorCheck = true;
          }
        }
      }, err => {
        this.OTPGenerated.emit(false);
        this.messageService.add({severity: 'error', summary: 'Generate OTP', detail: 'OTP sms generate failed'});
        this.errorCheck = true;
        console.error('ERROR', err);
      });

    } else if (this.otprequest.phoneNbr && this.otprequest.phoneNbr.toString().length === 10 && this.otprequest.phoneNbr.toString().charAt(0) > 4) {
      var data: any = {};
      data.category = this.otprequest.category;
      data.maMembershipId = this.otprequest.maMembershipId;
      data.phoneNbr = this.otprequest.phoneNbr;
      data.type = this.type;
      data.mailId = this.toLowerCase(this.otprequest.email);
      this.nms.generateOTP(data).subscribe((res: any) => {
        this.OTPGenerated.emit(true);
        if (res.code === 'SUCCESS') {          
         
          this.messageService.add({severity: 'success', summary: 'Generate OTP', detail: 'OTP Sent Successfully!'});
          this.showOrHide = true;
          this.errorCheck = false;
          
          setTimeout(() => {            
            this.otp0.nativeElement.value = '';
            this.otp0.nativeElement.focus();            
          }, 1000);
        } else {
          if (!isError) {
            isError = true;
            this.messageService.add({severity: 'error', summary: 'Generate OTP', detail: 'OTP sms generate failed'});
            this.showOrHide = true;
            this.errorCheck = true;
          }
        }
      }, err => {
        this.messageService.add({severity: 'error', summary: 'Generate OTP', detail: 'OTP sms generate failed'});
        this.errorCheck = true;
        console.error('ERROR', err);
      });
    } else {
      this.messageService.add({severity: 'error', summary: 'Generate OTP', detail: 'Enter valid mobile number'});
    }
  }

  verifyOTP() {
    var isError = false;
    if (this.otp0.nativeElement.value !== '' && this.otp0.nativeElement.value.length === 5) {
      if (this.otprequest.apiType != null && this.otprequest.apiType === "MEMBER_VERIFY") {
        var otpInfo: any = {};
          otpInfo.membershipNbr = this.otprequest.membershipNbr;
          otpInfo.cardHolderNbr = this.otprequest.cardHolderNbr;
          otpInfo.maMembershipId = this.otprequest.maMembershipId;
          otpInfo.otp =  this.otp0.nativeElement.value;

        this.nms.verifyMemberOTP(otpInfo).subscribe((res: any) => {
          if (res.code === 'SUCCESS' && res.response != null && res.response.status === 'VALID') {
            this.otpShowHide = true;
            localStorage.setItem('userToken', res.response.key);
             this.verifiedOTP.emit(true);
          } else if (res.response != null && res.response.status === 'INVALID') {
            setTimeout(() => {
              this.otp0.nativeElement.value = '';
              this.otp0.nativeElement.focus();
            }, 1000);
            this.messageService.add({
              severity: 'error',
              summary: 'Validate OTP',
              detail: 'INVALID OTP, Please enter valid OTP.'
            });
          } else {
            if (!isError) {
              isError = true;
              this.messageService.add({severity: 'error', summary: 'Validate OTP', detail: 'Error validating OTP.'});
            }
          }
        });

      } else if (this.otprequest.apiType != null && this.otprequest.apiType === "ONBOARDING_OTP_SMS") {
        this.nms.verifyOnboardOTP(this.otprequest.phoneNbr, this.otp0.nativeElement.value, localStorage.getItem('loginId')).subscribe((res: any) => {
          if (res.code === 'SUCCESS' && res.response != null && res.response.status != null && res.response.status === 'VALID') {
            this.otpShowHide = true;
            var otpResponse: any = {};
              otpResponse.otpId = res.response.Id;
              otpResponse.status = true;
              this.verifiedOTP.emit(otpResponse);
          } else if (res.response != null && res.response === 'INVALID') {
            setTimeout(() => {
              this.otp0.nativeElement.value = '';
              this.otp0.nativeElement.focus();
            }, 1000);
            this.messageService.add({
              severity: 'error',
              summary: 'Validate OTP',
              detail: 'INVALID OTP, Please enter valid OTP.'
            });
          } else {
            if (!isError) {
              isError = true;
              this.messageService.add({severity: 'error', summary: 'Validate OTP', detail: 'Error validating OTP.'});
            }
          }
        });

      } else {
        this.nms.verifyOTP(this.otprequest.phoneNbr, this.otp0.nativeElement.value, localStorage.getItem('loginId')).subscribe((res: any) => {
          if (res.code === 'SUCCESS' && res.response != null && res.response === 'VALID') {
            this.otpShowHide = true;
            this.verifiedOTP.emit(true);
          } else if (res.response != null && res.response === 'INVALID') {
            setTimeout(() => {
              this.otp0.nativeElement.value = '';
              this.otp0.nativeElement.focus();
            }, 1000);
            this.messageService.add({
              severity: 'error',
              summary: 'Validate OTP',
              detail: 'INVALID OTP, Please enter valid OTP.'
            });
          } else {
            if (!isError) {
              isError = true;
              this.messageService.add({severity: 'error', summary: 'Validate OTP', detail: 'Error validating OTP.'});
            }
          }
        });
      }
      
    } else {
      this.messageService.add({severity: 'warn', summary: 'Validate OTP', detail: 'Enter 5 Digit OTP'});
    }
  }

  private countDownTimer() {
    this.isCountDownExpired = false;
    const int = setInterval( () => {
      this.countDownTime -= 1;
      if ( this.countDownTime === 0 || this.countDownTime <= 0 ) {
        this.isCountDownExpired = true;
        clearInterval( int );
      }
    }, 1000);
  }

}


